// TODO: issue in update platform
import { call, put, takeLatest, CallEffect, PutEffect } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import client from '../../service/graphql';

import { IGraphQLResponse } from '../../types/commonTypes';
import {
  IAppointment,
  fetchAppointmentsFailure,
  fetchAppointmentsRequest,
  fetchAppointmentsSuccess,
  IFetchGetAppointmentsForCoachInput,
  createAppointmentRequest,
  ICreateAppointmentInput,
  deleteAppointmentRequest,
  deleteAppointmentSuccess,
  deleteAppointmentFailure,
  editAppointmentRequest,
  createAppointmentSuccess,
  createAppointmentFailure,
  editAppointmentSuccess,
  editAppointmentFailure,
  fetchSelectedClientAppointmentsRequest,
  fetchSelectedClientAppointmentsSuccess,
  fetchSelectedClientAppointmentsFailure,
  IFetchGetAppointmentsForClientInput,
} from './appointmentSlice';
import {
  CREATE_APPOINTMENT_MUTATION,
  DELETE_APPOINTMENT_MUTATION,
  GET_APPOINTMENTS_BY_CLIENT_QUERY,
  GET_APPOINTMENTS_BY_COACH_QUERY,
  UPDATE_APPOINTMENT_MUTATION,
} from '../../service/graphql/appointmentQuery';
import i18n from '../../i18n';
import { toastStyles } from '../../utils/utils';

interface IGetAllAppointmentsResponse {
  getAppointmentsByCoachId: IAppointment[];
}
interface IGetClientsAppointmentsResponse {
  getAppointmentsByClientId: IAppointment[];
}

interface ICreateAppointmentResponse {
  createAppointment: IAppointment;
}

interface IUpdateAppointmentResponse {
  updateAppointment: IAppointment;
}

interface IDeleteAppointmentResponse {
  deleteAppointment: {
    id: string;
  };
}

function* watchFetchAppointments({ payload }: PayloadAction<IFetchGetAppointmentsForCoachInput>) {
  const { coachId, from, to } = payload;

  try {
    const result: IGraphQLResponse<IGetAllAppointmentsResponse> = yield call(
      client.query.bind(client),
      {
        query: GET_APPOINTMENTS_BY_COACH_QUERY,
        variables: {
          coachId,
          from,
          to,
        },
      }
    );
    yield put(fetchAppointmentsSuccess(result.data.getAppointmentsByCoachId));
  } catch (error: unknown) {
    if (error instanceof Error) yield put(fetchAppointmentsFailure(error.message));
  }
}

function* watchCreateAppointment({ payload }: PayloadAction<ICreateAppointmentInput>) {
  try {
    const result: IGraphQLResponse<ICreateAppointmentResponse> = yield call(
      client.mutate.bind(client),
      {
        mutation: CREATE_APPOINTMENT_MUTATION,
        variables: {
          CreateAppointment: payload,
        },
      }
    );
    toast.success(i18n.t('appointments.appointmentCreated'), toastStyles.success);
    yield put(createAppointmentSuccess(result.data.createAppointment));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(createAppointmentFailure(error.message));
      toast.error(error.message, toastStyles.error);
    }
  }
}

function* watchDeleteAppointment({ payload }: PayloadAction<string>) {
  try {
    const result: IGraphQLResponse<IDeleteAppointmentResponse> = yield call(
      client.mutate.bind(client),
      {
        mutation: DELETE_APPOINTMENT_MUTATION,
        variables: {
          id: payload,
        },
      }
    );
    toast.success(i18n.t('appointments.appointmentDeleted'), toastStyles.error);
    yield put(deleteAppointmentSuccess(result.data.deleteAppointment.id));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(deleteAppointmentFailure(error.message));
      toast.error(error.message, toastStyles.error);
    }
  }
}

function* watchEditAppointment({ payload }: PayloadAction<ICreateAppointmentInput>) {
  try {
    const result: IGraphQLResponse<IUpdateAppointmentResponse> = yield call(
      client.mutate.bind(client),
      {
        mutation: UPDATE_APPOINTMENT_MUTATION,
        variables: {
          UpdateAppointment: payload,
        },
      }
    );
    toast.success(i18n.t('appointments.appointmentEdited'), toastStyles.success);
    yield put(editAppointmentSuccess(result.data.updateAppointment));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(editAppointmentFailure(error.message));
      toast.error(error.message, toastStyles.error);
    }
  }
}

function* watchFetchSelectedClientAppointments({
  payload,
}: PayloadAction<IFetchGetAppointmentsForClientInput>) {
  const { clientId, to, from } = payload;
  try {
    const result: IGraphQLResponse<IGetClientsAppointmentsResponse> = yield call(
      client.query.bind(client),
      {
        query: GET_APPOINTMENTS_BY_CLIENT_QUERY,
        variables: {
          clientId,
          to,
          from,
        },
      }
    );
    yield put(fetchSelectedClientAppointmentsSuccess(result.data.getAppointmentsByClientId));
  } catch (error: unknown) {
    if (error instanceof Error) yield put(fetchSelectedClientAppointmentsFailure(error.message));
  }
}

export function* watchAppointmentSagas() {
  yield takeLatest(fetchAppointmentsRequest, watchFetchAppointments);
  yield takeLatest(createAppointmentRequest, watchCreateAppointment);
  yield takeLatest(deleteAppointmentRequest, watchDeleteAppointment);
  yield takeLatest(editAppointmentRequest, watchEditAppointment);
  yield takeLatest(fetchSelectedClientAppointmentsRequest, watchFetchSelectedClientAppointments);
}

const appointmentSagas = watchAppointmentSagas;
export default appointmentSagas;
